import React, { useEffect, useRef, useState } from "react";
import { getApiCall, postApiCall, postFormApiCall } from "../../utils/api";
import MaterialTable from "material-table";
import tableIcons from "../component/MaterialIcon";
import { ThemeProvider, createTheme } from "@mui/material";
import {
  Close,
  Edit,
  RemoveRedEye,
} from "@material-ui/icons";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { CircleSpinnerOverlay } from "react-spinner-overlay";
import Select from "react-select";

const AddAminModuleLevelPermission = () => {
  const defaultMaterialTheme = createTheme();
  const [selectedRow, setSelectedRow] = useState(null);
  const inputRef = useRef(null);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [levelId, setLevelId] = useState("");

  const [userName, setUserName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [permissionLevel, setPermissionLevel] = useState([]);
  const [sidebarMenuList, setSidebarMenuList] = useState([]);
 
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {

    const res = await getApiCall("get-sidebar-admins");
    const menus = await getApiCall("get-sidebar-menu");
    console.log(res);
    
    setSidebarMenuList(menus.data);
    setData(res.data);
    res.data.forEach((data, index) => {
      data.serial = index + 1;
    });
    setLoading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("name", userName);
    formData.append("email", email);
    formData.append("permission_level", permissionLevel);
    formData.append("phone", phone);
    formData.append("password", password);
    formData.append("id", levelId);

    let res = {};
    if (levelId === "") {
      res = await postFormApiCall("add-admins", formData);
    } else {
      res = await postFormApiCall("update-admins", formData);
    }
    console.log(res);

    setLoading(false);
    if (res.success === false) {
      const errorText = Array.isArray(res.error)
        ? res.error.map((e) => e.message).join("\n")
        : res.message;

      return Swal.fire({
        title: "Error",
        text: errorText,
        icon: "error",
      });
    }
    Swal.fire({
      title: "Successful",
      text: res.message,
      icon: "success",
    });
    setLevelId("");
    setUserName("");
    setPhone("");
    setPassword("");
    setEmail("");
    setPermissionLevel([]);
    setLevelId("");
    fetchData();
  };

  const handleStatusChange = async (rowData, newStatus) => {
    const updatedStatus = newStatus === "Active";

    console.log("Row Data:", rowData.id);
    
    new Swal({
      title: "Are you sure, you want to make it " + newStatus + "?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const res = await postApiCall("update-sidebar-permission-status", {
          id: rowData.id,
          status: updatedStatus,
        });
        if (res.success === false) {
          return Swal.fire({
            title: "Error",
            text: res.message,
            icon: "error",
          });
        }
        Swal.fire({
          title: "Successful",
          text: res.message,
          icon: "success",
        });
        fetchData();
      }
    });
  };

  const columns = [
    { title: "Sl. no", field: "serial", width: "10%" },
    {
      title: "Name",
      field: "admin_name",
    },
    {
      title: "Email",
      field: "admin_email",
    },
    {
      title: "Permission Level",
      field: "sidebar_names",
      render: (rowData) => (
        <ul style={{ paddingLeft: "20px", margin: 0 }}>
          {rowData.sidebar_names?.map((name, index) => (
            <li key={index}>{name}</li>
          ))}
        </ul>
      ),
    },
    {
      title: "Status",
      field: "is_active",
      render: (rowData) => (
        <select
          value={rowData.is_active ? "Active" : "Inactive"}
          onChange={(e) => handleStatusChange(rowData, e.target.value)}
        >
          <option value="Active">Active</option>
          <option value="Inactive">Inactive</option>
        </select>
      ),
    },
  ];


  const handleEdit = async (rowData) => {
    console.log(rowData);
    
    setLevelId(rowData.id);
    setUserName(rowData.admin_name);
    setPhone(rowData.admin_phone);
    setEmail(rowData.admin_email);
    setPermissionLevel(rowData.sidebar_ids.toString());

    inputRef.current.focus();
    const input = document.getElementById("boardInput");
    input.focus();
  };

 
  return (
    <div>
      <div className="content-wrapper">
        <div className="content-header" style={{ backgroundColor: "#faebd7" }}>
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h4 className="m-0">Add Users</h4>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Add Users</li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 mt-4">
                <div className="card card-primary">
                  <div className="card-header">
                    <h3 className="card-title">Add User</h3>
                  </div>
                  <form onSubmit={handleSubmit} enctype="multipart/form-data">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4 col-sm-12">
                          <div className="form-group">
                            <label htmlFor="boardInput">User Name</label>
                            <input
                              type="text"
                              onChange={(e) => setUserName(e.target.value)}
                              className="form-control"
                              id="userName"
                              placeholder="Enter Name"
                              ref={inputRef}
                              value={userName}
                              name="username"
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-12">
                          <div className="form-group">
                            <label htmlFor="boardInput">User Email Id</label>
                            <input
                              type="text"
                              onChange={(e) => setEmail(e.target.value)}
                              className="form-control"
                              id="email"
                              placeholder="Enter Email ID"
                              ref={inputRef}
                              value={email}
                              name="email"
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-12">
                          <div className="form-group">
                            <label htmlFor="boardInput">Phone</label>
                            <input
                              type="tel"
                              onChange={(e) => setPhone(e.target.value)}
                              className="form-control"
                              id="phone"
                              placeholder="Enter Phone number"
                              ref={inputRef}
                              value={phone}
                              name="phone"
                            />
                          </div>
                        </div>
                        <div className="col-md-4 col-sm-12">
                          <div className="form-group position-relative">
                            <label htmlFor="password">Password</label>
                            <input
                              type={showPassword ? "text" : "password"}
                              onChange={(e) => setPassword(e.target.value)}
                              className="form-control"
                              id="password"
                              placeholder="Enter Password"
                              ref={inputRef}
                              value={password}
                              name="password"
                            />
                            <span
                              onClick={() => setShowPassword((prev) => !prev)}
                              style={{
                                position: "absolute",
                                top: "45px",
                                right: "10px",
                                cursor: "pointer",
                                zIndex: 2,
                                color: "#888",
                              }}
                            >
                              {showPassword ? <Close /> : <RemoveRedEye />}
                            </span>
                          </div>
                        </div>

                        {/* permission */}
                        <div className="col-md-4 col-sm-12">
                          <div class="form-group">
                            <label>Permission Level</label>
                            <Select
                              isMulti
                              options={sidebarMenuList.map((option) => ({
                                value: option.id,
                                label: option.name,
                              }))}
                              value={sidebarMenuList
                                .filter((option) =>
                                  permissionLevel.includes(option.id)
                                )
                                .map((option) => ({
                                  value: option.id,
                                  label: option.name,
                                }))}
                              onChange={(selectedOptions) => {
                                setPermissionLevel(
                                  selectedOptions.map((opt) => opt.value)
                                );
                              }}
                              placeholder="Select permissions"
                              classNamePrefix="react-select"
                              // styles={{
                              //   control: (base) => ({
                              //     ...base,
                              //     minHeight: "48px",
                              //     maxHeight: "45px",
                              //   }),
                              //   menu: (base) => ({
                              //     ...base,
                              //     maxHeight: "150px", // limits dropdown height
                              //     overflowY: "auto",
                              //   }),
                              // }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card-footer">
                      <button type="submit" className="btn btn-primary">
                        submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="content mt-4">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 mt-4">
                <div className="card card-primary">
                  <ThemeProvider theme={defaultMaterialTheme}>
                    <MaterialTable
                      icons={tableIcons}
                      title="Users"
                      columns={columns}
                      data={data}
                      onRowClick={(evt, selectedRow) =>
                        setSelectedRow(selectedRow.tableData.id)
                      }
                      options={{
                        exportButton: true,
                        actionsColumnIndex: -1,
                        headerStyle: {
                          backgroundColor: "rgb(0 123 255)",
                          color: "#FFF",
                          fontSize: 18,
                        },
                        rowStyle: (rowData, index) => ({
                          backgroundColor:
                            selectedRow === rowData.tableData.id
                              ? "#d3d4d1"
                              : index % 2 !== 0
                              ? "#EEE"
                              : "#FFF",
                        }),
                      }}
                      actions={[
                        {
                          icon: () => (
                            <span style={{ color: "#5656ce" }}>
                              <Edit />
                            </span>
                          ),
                          tooltip: "Edit",
                          onClick: (event, rowData) => handleEdit(rowData),
                        },
                        // (rowData) => ({
                        //   icon: () => (
                        //     <span style={{ color: "#5656ce" }}>
                        //       <Delete />
                        //     </span>
                        //   ),
                        //   tooltip: "Delete",
                        //   onClick: (event, rowData) => handleDelete(rowData),
                        // }),
                      ]}
                    />
                  </ThemeProvider>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <CircleSpinnerOverlay
        loading={loading}
        overlayColor="rgba(0,153,255,0.2)"
      />
    </div>
  );
};

export default AddAminModuleLevelPermission;
